import _ from 'lodash';

import './index.styl';

import template from './index.jst';
import Modal from '../Modal';

export default class TippingErrorsModal {
	constructor() {
		throw new Error("ErrorsModal class can't be an instance");
	}

	static show(errors) {
		errors = _.isArray(errors) ? errors.map(({ text }) => text) : [errors];

		Modal.create({
			template: template({ errors }),
			events: {
				'click .js-close': 'close'
			}
		});
	}
}